import React from 'react';
interface DualRangeSliderProps {
  label: string;
  min: number;
  max: number;
  step: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
  format: (value: number) => string;
}
export function DualRangeSlider({
  label,
  min,
  max,
  step,
  value,
  onChange,
  format
}: DualRangeSliderProps) {
  const [lo, hi] = value;
  const left = (lo - min) / (max - min) * 100;
  const right = (hi - min) / (max - min) * 100;
  return <div data-id="element-772" data-mp="1fkq1oh4pz53c">
      <div className="mb-2 flex items-baseline justify-between" data-id="element-773" data-mp="1fkzm7p6zwk1n">
        <span className="text-[15px] font-bold" data-id="element-774" data-mp="1kh6sjj3azxk4">{label}</span>
        <span className="tabular text-[15px] font-bold text-brand-strong" data-id="element-775" data-mp="15td8nm76q8vq">
          {format(lo)} – {hi >= max ? `${format(max)}+` : format(hi)}
        </span>
      </div>
      <div className="relative h-7" data-id="element-776" data-mp="1yhhjem4m5c5a">
        <div className="absolute inset-x-0 top-1/2 h-1.5 -translate-y-1/2 rounded-full bg-line" data-id="element-777" data-mp="1yh98gzs1wgwq" />
        <div className="absolute top-1/2 h-1.5 -translate-y-1/2 rounded-full bg-brand" style={{
        left: `${left}%`,
        width: `${right - left}%`
      }} data-id="element-778" data-mp="238hiny17g6ay" />
        <input type="range" className="range range-dual" min={min} max={max} step={step} value={lo} aria-label={`${label} minimum`} onChange={e => onChange([Math.min(Number(e.target.value), hi - step), hi])} data-id="element-779" data-mp="20qe7ekda5jkb" />
        <input type="range" className="range range-dual" min={min} max={max} step={step} value={hi} aria-label={`${label} maximum`} onChange={e => onChange([lo, Math.max(Number(e.target.value), lo + step)])} data-id="element-780" data-mp="2ofgmplkfz0bn" />
      </div>
    </div>;
}